import "./ship-spinner.sass";

export const Ship = () => {
  return (
    <div className="sea">
      <div className="simple-cruiser">
        <div className="deck">
          <div className="logo">
            <span className="a">A</span>
            <span className="i">I</span>
            <span className="d">D</span>
            <span className="a2">A</span>
          </div>
        </div>
        <div className="smokestack"></div>
        <div className="flag"></div>
        <div className="windows">
          <div className="window"></div>
          <div className="window"></div>
          <div className="window"></div>
          <div className="window"></div>
          <div className="window"></div>
        </div>
        <div className="banner-connector"></div>
        <div className="banner">Loading...</div>
      </div>
    </div>
  );
};
